import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-my-course-lesson-route.tsx
var LazyMyCourseLessonRoute = lazy(() => import("./my-course-lesson-route-BCG20RtL.js").then((n) => n.n).then((module) => ({ default: module.MyCourseLessonRoute })));
function MyCourseLessonRoute({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyMyCourseLessonRoute, { ...props })
	});
}
var useMyCourseLessonRoute = () => {
	return useMemo(() => ({ "my-course-lesson-route": { component: MyCourseLessonRoute } }), []);
};
//#endregion
export { useMyCourseLessonRoute };
